import { gql } from "@apollo/client";

export const CREATE_COLLEGE_IP = gql`
  mutation CreateCollegeIpAddress($input: CreateCollegeIpAddressInput!) {
    createCollegeIpAddress(input: $input) {
    success
    message
    record {
      id
      collegeObjectId
      ipAddress
      status
      expiry
      createdAt
      updatedAt
      createdById
      updatedById
      createdByName
      updatedByName
    }
  }
  }
`;


export const UPDATE_COLLEGE_IP = gql`
  mutation updateCollegeIpAddress($input: UpdateCollegeIpAddressInput!) {
    updateCollegeIpAddress(input: $input) {
      success
      message
    }
  }
`;


export const DELETE_COLLEGE_IP = gql`
  mutation DeleteCollegeIpAddress($id: Int!) {
    deleteCollegeIpAddress(id: $id) {
      success
      message
    }
  }
`;



